var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4759 9.4348L9.43492 14.4758C8.78735 13.8283 8.38885 12.9416 8.38885 11.9553C8.38885 9.98273 9.98285 8.38873 11.9554 8.38873C12.9417 8.38873 13.8284 8.78723 14.4759 9.4348Z",
    stroke: "#797979",
    strokeWidth: 1.49438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7529 5.74848C16.0095 4.43343 14.017 3.71613 11.9548 3.71613C8.43799 3.71613 5.16033 5.78833 2.87891 9.37483C1.98229 10.7795 1.98229 13.1407 2.87891 14.5454C3.66595 15.7807 4.5825 16.8467 5.57875 17.7035",
    stroke: "#797979",
    strokeWidth: 1.49438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38852 19.457C9.52424 19.9352 10.7297 20.1942 11.9551 20.1942C15.4719 20.1942 18.7495 18.122 21.0309 14.5355C21.9276 13.1308 21.9276 10.7697 21.0309 9.36494C20.7022 8.84689 20.3435 8.35873 19.9749 7.90045",
    stroke: "#797979",
    strokeWidth: 1.49438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4527 12.6533C15.1937 14.058 14.048 15.2037 12.6433 15.4627",
    stroke: "#797979",
    strokeWidth: 1.49438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.43525 14.476L1.99326 21.918",
    stroke: "#797979",
    strokeWidth: 1.49438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9179 1.9931L14.4759 9.43509",
    stroke: "#797979",
    strokeWidth: 1.49438,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeclose);
export default __webpack_public_path__ + "static/media/eyeclose.839d65bdc6d110d44f0ff829e4570d54.svg";
export { ForwardRef as ReactComponent };